import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";
import { TipoProcesso } from "../../types/tipoProcesso/TipoProcesso";


const endpointUrl = configUrls.TIPO_PROCESSO_EP



function createTipoProcesso(obj: TipoProcesso) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateTipoProcesso(obj: TipoProcesso) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteTipoProcesso({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getTipoProcessos(search: string) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}




export const tipoProcessoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getTipoProcesso: query<TipoProcesso, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["TipoProcesso"],
        }),

        getTipoProcessos: query<TipoProcesso[], string>({
            query: getTipoProcessos,
            providesTags: ["TipoProcesso"],
        }),



        createTipoProcesso1: mutation<TipoProcesso, TipoProcesso>(
            {
                query: createTipoProcesso,
                invalidatesTags: ["TipoProcesso"]
            }),


        createTipoProcesso: mutation<TipoProcesso, TipoProcesso>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o tipoprocesso
                    body: obj,         // Corpo da requisição com os dados do novo tipoprocesso
                }),
                invalidatesTags: ["TipoProcesso"]
            }),

        updateTipoProcesso: mutation<TipoProcesso, TipoProcesso>({
            query: updateTipoProcesso,
            invalidatesTags: ["TipoProcesso"]
        }),

        deleteTipoProcesso: mutation<TipoProcesso, { id: string }>(
            {
                query: deleteTipoProcesso,
                invalidatesTags: ["TipoProcesso"],
            }),


    }),

});
export const {
    useGetTipoProcessoQuery,
    useGetTipoProcessosQuery,
    useCreateTipoProcessoMutation,
    useUpdateTipoProcessoMutation,
    useDeleteTipoProcessoMutation,
    useCreateTipoProcesso1Mutation,
} = tipoProcessoApiSlice